import Scrollable from 'common/Scrollable';
import React, { memo, useCallback, useContext, useEffect, useState } from 'react';
import GET_SPECIFICATION_FOLDER_CONTENTS_DATA from 'api/queries/GET_SPECIFICATION_FOLDER_CONTENTS_DATA';
import { unwrapPagedCollections } from 'parsers/helpers';
import { useQuery } from '@apollo/client';
import { WarehouseReleaseContext } from 'views/WarehouseReleasesList/WarehouseReleaseProvider';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import WarehouseReleaseSpecification from './WarehouseReleaseSpecification';
import { WarehouseReleaseSpecificationFolderTitle } from './WarehouseReleaseSpecificationFolderTitle';
import './WarehouseReleaseSpecificationView.scss';
const WarehouseReleaseSpecificationView = ({ hideModal }) => {
    const [folderContentsData, setFolderContentsData] = useState();
    const [folderId, setFolderId] = useState();
    const { data: rootFolderData } = useQuery(GET_CURRENT_TENANT);
    const { data: folderData, refetch } = useQuery(GET_SPECIFICATION_FOLDER_CONTENTS_DATA, {
        variables: {
            modelSpecificationFolderId: folderId,
            state: ['PRODUCTION'],
        },
        fetchPolicy: 'network-only',
        skip: !rootFolderData,
    });
    useEffect(() => {
        var _a, _b, _c;
        setFolderId((_c = (_b = (_a = rootFolderData === null || rootFolderData === void 0 ? void 0 : rootFolderData.me) === null || _a === void 0 ? void 0 : _a.currentTenant) === null || _b === void 0 ? void 0 : _b.rootFolder) === null || _c === void 0 ? void 0 : _c.id);
    }, [rootFolderData]);
    useEffect(() => {
        setFolderContentsData(unwrapPagedCollections(folderData === null || folderData === void 0 ? void 0 : folderData.node));
    }, [folderData]);
    const refetchFolderContentsData = (modelSpecificationFolderId) => {
        refetch({
            modelSpecificationFolderId,
        });
    };
    const handleHideModal = useCallback(() => {
        hideModal();
    }, [hideModal]);
    const { warehouseRelease: warehouseReleaseContext } = useContext(WarehouseReleaseContext);
    const getSpecificationCatalogs = (catalogFolder) => (React.createElement("div", { className: "WarehouseReleaseSpecificationView" },
        React.createElement("div", { className: "SpecificationFolderContents w-1" },
            React.createElement("div", { className: "SpecificationFolderContents__subfolders wrapper__list" },
                catalogFolder.parentFolder && (React.createElement(WarehouseReleaseSpecificationFolderTitle, { key: "..", folder: catalogFolder.parentFolder, isParentFolder: true, className: "wrapper__specification", handleFolderRefresh: refetchFolderContentsData })),
                catalogFolder.folders.map((subfolder) => (React.createElement(WarehouseReleaseSpecificationFolderTitle, { key: subfolder.id, className: "wrapper__specification", folder: subfolder, handleFolderRefresh: refetchFolderContentsData })))),
            React.createElement("div", { className: "SpecificationFolderContents__specifications wrapper__list" }, catalogFolder &&
                catalogFolder.modelSpecifications.map((specification) => {
                    var _a, _b;
                    return (React.createElement(WarehouseReleaseSpecification, { key: specification.id, modelSpecification: specification, hideModal: handleHideModal, disabled: ((_b = (_a = warehouseReleaseContext === null || warehouseReleaseContext === void 0 ? void 0 : warehouseReleaseContext.warehouseReleaseModel) === null || _a === void 0 ? void 0 : _a.modelSpecification) === null || _b === void 0 ? void 0 : _b.id) ===
                            specification.id }));
                })))));
    return (React.createElement("div", { className: "WarehouseRelaseSpecifications" },
        React.createElement("div", null,
            React.createElement(Scrollable, { className: "wrapper__main", padding: 10, scrollbarClassName: "WarehouseRelaseSpecifications__modal mt-4" }, folderContentsData && getSpecificationCatalogs(folderContentsData)))));
};
export default memo(WarehouseReleaseSpecificationView);
